import React, {useEffect, useState} from 'react';

import styles from '../../Parts.module.css';
import {Button} from "../../../../ui/General/LucideButton/LucideButton.tsx";
import {Product} from "../../../../widgets/ProductCard/types/productCard.interface.ts";
import {useScreenDetector} from "../../../../hooks/useScreenDetector.ts";
import {LinearLoader} from "../../../../ui/LinearLoader/LinearLoader.tsx";
import { API_URL } from '../../../../config.tsx';

interface Props {
    products: Product[],
    querySearch?: string,
    isLoading?: boolean,
}

interface PropsProductRow {
    productId: number,
    template: string,
}

const ProductRow: React.FC<PropsProductRow> = ({productId, template}) => {
    const [productData, setProductData] = useState<Product|null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const setData = (productId: number) => {
        fetch(`${API_URL}/find_public_part/${productId}`, {
            method: 'GET',
            credentials: 'include',
        })
            .then(response => response.json())
            .then(data => setProductData(data))
            .then(() => setIsLoading(false))
    }

    useEffect(() => {
        if(productId) setData(productId);
    }, [productId]);
    if(isLoading) return <div className={styles.row} style={{width: '100%',display: 'block'}}><LinearLoader/></div>;

        if(!productData) return null;

    const {name, img, article, brand, link} = productData;

    if(template === 'desktop') {
        return (<div className={styles.row}>
            <div className={styles.rowItem}>{brand}</div>
            <div className={styles.rowItem}>{article}</div>
            <div className={styles.rowItem}>
                <img width={48} height={48} src={img} alt={name}/>
            </div>
            <div className={styles.rowItem}>{name}</div>
            <div className={styles.rowItem}>
                    <a href={link}>Узнать цены</a>
            </div>
        </div>);
    }

    return (
        <li key={productId} className={styles.product}>
            <h4 className={styles.title}>{name}</h4>
            <div className={styles.outline}></div>
            <div className={styles.info}>
                <img className={styles.img} width={100} height={100} src={img} alt={name}/>
                <div className={styles.brand}>{brand}</div>
                <div className={styles.productId}>{article}</div>
                <a href={link}>Узнать цены</a>
            </div>
        </li>
    )
}

export const SearchProductList: React.FC<Props> = ({products, querySearch,isLoading}) => {
    const {isMobile, isDesktop} = useScreenDetector()
    const [productsLength, setProductsLength] = useState(5);

    // State for sorting and pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage] = useState(10); // Number of products per page

    if (typeof window !== 'undefined') {
        window.onscroll = function () {
            if(document.getElementById('filter')) { // @ts-ignore
                if (document.documentElement.scrollTop > document.body.clientHeight - document.getElementById('filter').offsetHeight - window.innerHeight) {
                    setProductsLength(productsLength + 5);
                }
            }
        }
    }

    // Sorting logic

    // Pagination logic
  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(products.length / productsPerPage);

  // Next/Previous page
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

    return (
        <div className={styles.productsTable}>
            <div className={styles.tableCard}>
                <div className={styles.tableHeader}>
                    <div className={styles.headerGrid}>
                        <div className="col-span-2">ПРОИЗВОДИТЕЛЬ</div>
                        <div className="col-span-2">АРТИКУЛ</div>
                        <div className="col-span-1">ФОТО</div>
                        <div className="col-span-5">ОПИСАНИЕ</div>
                        <div className="col-span-2 text-center">ДЕЙСТВИЯ</div>
                    </div>
                </div>
                <div className={styles.tableBody}>
                {isLoading && (
                    <div className={styles.loadingMessage}>
                    Загрузка...
                    </div>
                )}
                {currentProducts.map((product, index) => (
                    <div key={index} className={styles.productRow}>
                   <div className="w-full md:col-span-2">
                      <span className={styles.productBrand}>{product.brand}</span>
                    </div>
                    <div className="w-full md:col-span-2">
                        <span className={styles.productArticle}>{product.article}</span>
                    </div>
                    <div className="w-full col-span-1 flex justify-center md:justify-start">
                        <img
                        src={product.img_thumbnail}
                        className={styles.productImage}
                        />
                    </div>
                    <div className="w-full md:col-span-5">
                      <span className={styles.productDescription}>{product.name}</span>
                    </div>
                    <div className="w-full md:col-span-2 flex justify-center">
                        <a href={product.link}>
                            <Button
                                className={styles.actionButton}
                                id={`search-product-btn-${product.productId}`}
                                size="sm"
                                style={{textDecoration: 'none'}}
                            >
                            Узнать цены
                            </Button>
                        </a>
                    </div>
                    </div>
                ))}
                </div>

                <div className={styles.pagination}>
                    <Button
                        onClick={prevPage}
                        disabled={currentPage === 1}
                        size="sm"
                        variant="outline"
                        className={styles.paginationButton}
                    >
                        Предыдущая
                    </Button>
                    <div className={styles.pageInfo}>
                        Страница {currentPage} из {totalPages}
                    </div>
                    <Button
                        onClick={nextPage}
                        disabled={currentPage === totalPages}
                        size="sm"
                        variant="outline"
                        className={styles.paginationButton}
                        >
                        Следующая
                    </Button>
                </div>
            </div>
        </div>
    );
    return (<>
        {isDesktop && (
            <div className={styles.table}>
                <div className={styles.header}>
                    <div className={styles.headerItem}>Производитель</div>
                    <div className={styles.headerItem}>Артикул</div>
                    <div className={styles.headerItem}>Фото</div>
                    <div className={styles.headerItem}>Описание</div>
                    <div className={styles.headerItem}></div>
                </div>
                {products.map((product, key) => {
                    if(key > productsLength) return null;
                        return <ProductRow key={product.productId} productId={product.productId} template="desktop" />
                    }
                )}
            </div>
        )}

        {isMobile && (
            <div className={styles.wrapper}>
                {querySearch && (
                    <div className={styles.searchResults}>По запросу «{querySearch}» найдено {products.length} товаров</div>
                )}
                <ul className={styles.productList}>
                    {products.map((product, key) => {
                            if(key > productsLength) return null;
                            return <ProductRow key={product.productId} productId={product.productId} template="mobile" />
                        }
                    )}
                </ul>
            </div>
        )}
    </>);
};
